export default __webpack_public_path__ + "static/principles-of-use-do-dark-70d50caa81ee80bbf62a597cef42a05c95b396832f7cab345523cfbe69bc8da6.png";